module.exports = __webpack_public_path__ + "static/media/pastoral-smart.0a0b549c.svg";